/**
 * Adapptio library to help creating components.
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { createContext, useContext } from "react";
import { DesignContext, MEDIA_RESOLUTIONS_string } from "@adapptio/lib-blueprint";

import { EditDnD } from "./EditDnD";
import { EditSelection } from "./EditSelection";

export interface IEditContextValue {
	/** Selection class */
	selection: EditSelection;

	/** Drag'n'drop state */
	componentDnD: EditDnD;

	/** Design context */
	dCtx: DesignContext;

	/** Event sampling rate */
	editorEventSamplingRateMs?: number;

	/** Current media */
	media?: MEDIA_RESOLUTIONS_string;
}

/**
 * Edit context
 *
 * Provides interface between components and editor
 */
export const EditContext = createContext<IEditContextValue>(null);

export function useEditContext(): IEditContextValue {
	return useContext(EditContext);
}
